export const SETTINGS_CUSTOMER_STARTUP_KEY = 'settings.customer.startupPage'
export const SETTINGS_USER_STARTUP_KEY = 'settings.user.startupPage'
